import { Component, computed, inject, OnInit } from "@angular/core";
import {
  NavigationEnd,
  NavigationStart,
  Router,
} from "@angular/router";
import { TitleService, VERSION as VERSION_ALAIN } from "@delon/theme";
import { NzModalService } from "ng-zorro-antd/modal";
import { filter } from "rxjs/operators";
import {
  AnalyticsService,
  AuthenticationService,
  HttpCancelService,
  NotificationService,
} from "@core";
import { StorageService } from "./core/services/storage/storage.service";
import { BrowserStorageKeys } from "./core/config/browser-storage-keys.config";
import { API_ResponseStatus } from "./core/config/api-response.config";
import { Subscription } from "rxjs";
import { IconService } from "./core/services/icon/icon.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "@env/environment";
import { pageRoutes } from "./core/config/page-routes.config";
@Component({
  selector: "app-root",
  standalone: false,
  template: `
    <ng-progress #progressBar></ng-progress>
    <simple-notifications></simple-notifications>

    <div
      [NotificationCategory]="platformNotifications[0]?.category"
      class="disclaimer-notification"
      *ngIf="isDisclaimerModalViewed"
    >
      <p>
        <svg-icon src="assets/icons/disclaimer-icon.svg"></svg-icon>
        <span>{{ platformNotifications[0]?.text }}</span>
      </p>
    </div>

    <div [ngClass]="isDisclaimerModalViewed ? 'router-outlet' : ''">
      <router-outlet></router-outlet>
      @if(storageService.userTokenExists() && !this.route.includes('enquiry')) {

      <div>
        <nz-float-button-group
          (click)="togglePanel()"
          (mouseenter)="showPanel = true"
          (mouseleave)="showPanel = false"
          nzShape="circle"
        >
          <button
            class="float-btn"
            nz-float-button
            nzTrigger="hover"
            nzPlacement="left"
            nzType="primary"
            nzTooltipTitle="Support"
          >
            <img
              src="assets/icons/float-icon.png"
              alt="support"
              class="float-icon"
            />
          </button>
          <div class="enquiry-panel" [class.show]="showPanel">
            <span>{{'APP.MAKE_ENQUIRY' | translate}}</span>
          </div>
        </nz-float-button-group>
      </div>
      }
    </div>

    <div
      *ngIf="environment?.translation"
      class="global-lang-switch"
      appDraggable
      [storageKey]="'lang-switcher-position'"
      (positionChange)="onLanguageSwitcherPositionChange($event)"
    >
      <span
        (click)="switchLanguage('en')"
        [class.active]="currentLang === 'en'"
      >
        EN
      </span>
      <span class="divider">|</span>
      <span
        (click)="switchLanguage('fr')"
        [class.active]="currentLang === 'fr'"
      >
        FR
      </span>
    </div>

    <router-outlet></router-outlet>
  `,
})
export class AppComponent implements OnInit {
  isDisclaimerViewed: boolean = false;
  platformNotifications: any = [];
  utmSource: string | null = null;
  showPanel: boolean = false;
  isLoggedIn: boolean = false;
  route: string = "";
  currentLang: string = "en";
  protected readonly environment = environment;
  private tokenSub!: Subscription;
  storageService = inject(StorageService);

  route_exceptions = [
    `${pageRoutes.access.accessing}?processor`,
    `${pageRoutes.access.sharing}?processor`,
    `${pageRoutes.access.accessing}`,
    `${pageRoutes.access.sharing}`,
    `${pageRoutes.access.recovery}`,
    `${pageRoutes.confirmation.singleConfirmation}`,
    `${pageRoutes.confirmation.bulkConfirmation}`,
    `${pageRoutes.billing.billing}`,
    `${pageRoutes.billing}?processor`,
    `${pageRoutes.confirmation.bulkConfirmation}?processor`,
    `${pageRoutes.passport.account}`,
    `${pageRoutes.public.paymentLink}`,
    `${pageRoutes.sharedCertificates.previewSharedCertificate}`
  ];

  constructor(
    private router: Router,
    private titleSrv: TitleService,
    private modalSrv: NzModalService,
    private httpCancelService: HttpCancelService,
    private notificationService: AuthenticationService,
    public notifyService: NotificationService,
    private iconService: IconService,
    private translate: TranslateService,
    private analytics: AnalyticsService,
  ) {
    this.initializeTranslator();
    this.analytics.init();
    // this.registerIcons();
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        const url = new URL(event.url, window.location.origin);
        this.route = url?.href;
        const utmSource = url.searchParams.get("utm_source");
        if (utmSource) {
          this.storageService.setUtmSource(utmSource);
        }
      }
    });

    this.gePlatformNotification();
    this.router.events
      .pipe(filter((evt) => evt instanceof NavigationEnd))
      .subscribe((e: any) => {
        this.titleSrv.setTitle();
        this.modalSrv.closeAll();
        if (
          this.excemptRoutesFromCancellingRequests(e.urlAfterRedirects) == 0
        ) {
          this.httpCancelService.cancelPendingRequests();
        }
      });
  }

  excemptRoutesFromCancellingRequests(url: string) {
    return this.route_exceptions.filter(
      (i) => i == url.substring(0, this.checkLength(i)),
    ).length;
  }

  initializeTranslator() {
    this.translate.setDefaultLang("en");
    const savedLang = localStorage.getItem("app-language");

    if (savedLang) {
      this.currentLang = savedLang;
      this.translate.use(savedLang);
      return;
    }
    
    const browserLang = this.translate.getBrowserLang() || "en";
    const langToUse = browserLang.match(/en|fr/) ? browserLang : "en";
    this.translate.use(langToUse);
    this.currentLang = langToUse;
    localStorage.setItem("app-language", langToUse);
    // this.translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
  }

  switchLanguage(lang: string) {
    this.translate.use(lang);
    this.currentLang = lang;
    localStorage.setItem("app-language", lang);
  }

  checkLength(value: string) {
    return value.length;
  }

  registerIcons() {
    this.iconService.registerIcons([
      { name: "waec-chevron-down", link: "assets/v2/icons/chevron-down.svg" },
      { name: "waec-chevron-right", link: "assets/v2/icons/chevron-right.svg" },
    ]);
  }

  get isDisclaimerModalViewed() {
    const isViewed = this.storageService.getSessionStorageItem(
      BrowserStorageKeys.disclaimerViewed,
    );
    this.isDisclaimerViewed = !!isViewed;

    if (!!isViewed && this.platformNotifications?.length) {
      return true;
    }

    return false;
  }

  gePlatformNotification() {
    const status = "active";
    this.notificationService.getPlatformNotifications().subscribe(
      (res: any) => {
        if (res?.status === API_ResponseStatus.FAILED) return;
        this.platformNotifications = res?.data?.filter(
          (e: any) => e?.status === status,
        );
      },
      (err) => console.error(err),
    );
  }

  togglePanel() {
    this.showPanel = !this.showPanel;
    this.router.navigate([pageRoutes.enquiry.openTicket]);
  }

  onLanguageSwitcherPositionChange(position: any) {
    
  }

  ngOnDestroy(): void {
    this.tokenSub.unsubscribe();
  }
}
